import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  tableIcon: {
    fontSize: 20,
    color: theme.palette.primary.main,
    marginTop: '3px',
    marginLeft: '7px',
  },

  group: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: '0.5rem 0',
  },

  groupText: {
    marginLeft: '10px',
    margin: 0,
    padding: 0,
    fontFamily: 'Nunito !important',
    fontSize: '14px !important',
    lineHeight: '20px !important',
    fontWeight: '400 !important',
    maxWidth: '300px !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  text: {
    minWidth: '100px',
    maxWidth: '120px !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  subTitle: {
    opacity: 0.5,
    fontSize: '13px !important',
  },
}))

export { useStyles }
